module.exports = __webpack_public_path__ + "img/sheep.bc26e56.png";